import { render, staticRenderFns } from "./ShowPromoCode.vue?vue&type=template&id=3882a5bc&"
import script from "./ShowPromoCode.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShowPromoCode.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports